﻿﻿export interface IHlaAvoids {
    aAvoids: number[];
    bAvoids: number[];
    drAvoids: number[];
    bwAvoids: number[];
    cwAvoids: number[];
    dqAvoids: number[];
    dpAvoids: number[];
    dqaAvoids: number[];
    avoidDr51: boolean;
    avoidDr52: boolean;
    avoidDr53: boolean;
}
